<template>
    <div class="inner_icon" v-html="icon"></div>
</template>

<script>
function recursivelySetColour(el, colour) {
    if (!el) {
        return;
    }
    el.setAttribute('fill', colour);
    [].forEach.call(el.children, child => {
        recursivelySetColour(child);
    });
}
export default {
    name: 'svg-icon',
    props: {
        icon: {
            type: String,
            default: null
        },
        setColour: {
          type: String,
          default: "#000000"
        },
        growByHeight: {
            type: Boolean,
            default: true
        },
    },
    mounted() {
        if (this.$el.firstElementChild.nodeName === 'svg') {
            const svgElement = this.$el.firstElementChild;
            // use `viewBox` attribute to get the svg's inherent width and height
            const viewBox = svgElement.getAttribute('viewBox').split(' ').map(n => Number(n));
            const widthToHeight = (viewBox[2] / viewBox[3]).toFixed(2);
            if (this.setColour) {
                // recursively remove all fill attribute of element and its nested children
                recursivelySetColour(svgElement, this.setColour);
            }
            // set width and height relative to font size
            // if growByHeight is true, height set to 1em else width set to 1em and remaining is calculated based on widthToHeight ratio
            if (this.growByHeight) {
                svgElement.setAttribute('height', '1em');
                svgElement.setAttribute('width', `${widthToHeight}em`);
            } else {
                svgElement.setAttribute('width', '1em');
                svgElement.setAttribute('height', `${1 / widthToHeight}em`);
            }
            svgElement.classList.add('svg-class');
        }
    }
}
</script>

<style lang="scss" scoped>
  .inner_icon {
    font-size: 42px;
    background-color: #FFFFFF;
    height: 3em;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div[id*='white'] {
    div {
      background-color: var(--brand-purple);
    }
  }

  .svg-class {
    margin: 0
  }
</style>
